const buildPrefixedClassToken = (token, prefix) => (prefix ? `${prefix}:${token}` : token);

export default buildPrefixedClassToken;
